
<template>
  <footer class="footer-fixed">
    <div class="footer-content">
      <p>
        © 2025 Digital Twin Hub. All rights reserved. | 致力于推动数字孪生技术发展 |
        <span class="icp-info">
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025153900号-1</a>
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSectionComponent'
};
</script>

<style scoped>
.footer-fixed {
  padding: 12px 20px;
  min-height: 32px;
  font-size: 13px;
  background: rgba(10, 14, 39, 0.5);
  color: #a0a8c5;
  border-top: 1px solid rgba(255,255,255,0.08);
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.footer-content p {
  margin: 0;
}
.icp-info {
  font-size: 12px;
}
.icp-info a {
  color: #a0a8c5;
  text-decoration: none;
  transition: color 0.2s;
}
.icp-info a:hover {
  color: #ffffff;
  text-decoration: underline;
}
</style>
